module.exports = __webpack_public_path__ + "static/media/매인페이지2.42f1a6cd.png";